var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.91352 27.5108C9.52978 27.5101 9.15284 27.4095 8.81977 27.219C8.06977 26.794 7.60352 25.969 7.60352 25.0733V6.94835C7.60352 6.05023 8.06977 5.22773 8.81977 4.80273C9.16077 4.60675 9.54815 4.50597 9.94143 4.51092C10.3347 4.51586 10.7194 4.62636 11.0554 4.83085L26.546 14.1033C26.8689 14.3058 27.135 14.5869 27.3195 14.9203C27.504 15.2537 27.6007 15.6285 27.6007 16.0096C27.6007 16.3907 27.504 16.7655 27.3195 17.0989C27.135 17.4323 26.8689 17.7134 26.546 17.9158L11.0529 27.1908C10.7091 27.3987 10.3153 27.5093 9.91352 27.5108Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlay);
export default __webpack_public_path__ + "static/media/ic-play.dc5fa1b5096dd009a65a8793f08d3e18.svg";
export { ForwardRef as ReactComponent };